import React from 'react';
const STAR_POINTS = '0,-1.6 0.359,-0.494 1.522,-0.494 0.581,0.189 0.941,1.294 0,0.611 -0.941,1.294 -0.581,0.189 -1.522,-0.494 -0.359,-0.494';
const STAR_POSITIONS: Array<[number, number]> = [[18, 9], [13.2, 6.4], [22.8, 6.4], [13.2, 11.6], [22.8, 11.6]];
type HonduranFlagProps = {
  className?: string;
};
/**
 * Flag of Honduras rendered as crisp vector art so it stays sharp at any size.
 * Decorative by default: callers control opacity and layering.
 */
export function HonduranFlag({
  className = ''
}: HonduranFlagProps) {
  return <svg viewBox="0 0 36 18" preserveAspectRatio="xMidYMid slice" aria-hidden="true" focusable="false" className={className} data-id="element-3337" data-mp="3l0uowewbz2xm">
      <rect x="0" y="0" width="36" height="18" fill="#ffffff" data-id="element-3338" data-mp="3b3q1ycunv3fr" />
      <rect x="0" y="0" width="36" height="6" fill="#0073cf" data-id="element-3339" data-mp="1uqhqztuwqd9t" />
      <rect x="0" y="12" width="36" height="6" fill="#0073cf" data-id="element-3340" data-mp="1up6ixhufijcw" />
      {STAR_POSITIONS.map(([cx, cy]) => <polygon key={`${cx}-${cy}`} points={STAR_POINTS} fill="#0073cf" transform={`translate(${cx} ${cy})`} data-id="element-3341" data-mp="1znht5tomyvvn" />)}
    </svg>;
}